/*
 * WARNING: THIS IS AN AUTOGENERATED-FILE. DO NOT MANUALLY EDIT THIS FILE.
 *
 * MODIFY FLAGS DATA IN rubeos/src/lib/gating.rb AND RUN `bundle exec bin/generate-ts-constants`
 * TO REGENERATE THIS FILE.
 */

export enum Feature {
  ProdEnvironmentIndicator = "ProdEnvironmentIndicator",
  ColumnHooks = "ColumnHooks",
  EventHooks = "EventHooks",
  AllowRemoveLogo = "AllowRemoveLogo",
  AdvancedBranding = "AdvancedBranding",
  I18N = "I18N",
  HideImportActivityPreview = "HideImportActivityPreview",
  CustomColumns = "CustomColumns",
  ValidationWebhooks = "ValidationWebhooks",
  Headless = "Headless",
  HeadlessValidation = "HeadlessValidation",
  DynamicTemplates = "DynamicTemplates",
  AuditLogs = "AuditLogs",
  ExtendedMetadataWebhookTimeout = "ExtendedMetadataWebhookTimeout",
  AdvancedMappings = "AdvancedMappings",
  CustomEnvironments = "CustomEnvironments",
  CodeHooksV1 = "CodeHooksV1",
  Customizations = "Customizations",
  CustomizationCustomStylesheet = "CustomizationCustomStylesheet",
  Integrations = "Integrations",
  TestMaskDataHighlighting = "TestMaskDataHighlighting",
  InAppBilling = "InAppBilling",
  ValidationWebhooksUnmappedCols = "ValidationWebhooksUnmappedCols",
  TemplateColumnsOrder = "TemplateColumnsOrder",
  LockColumns = "LockColumns",
  UserRoleManagement = "UserRoleManagement",
  FileFeeds = "FileFeeds",
  SelfServeTrial = "SelfServeTrial",
  ServerReachabilityPing = "ServerReachabilityPing",
  DebugTemplatesEndpointLag = "DebugTemplatesEndpointLag",
  EmbeddedPipelineBuilder = "EmbeddedPipelineBuilder",
  DisableDateAutoFormatting = "DisableDateAutoFormatting",
  SuggestedTransforms = "SuggestedTransforms",
  PipelineStepRunPostMappingHooks = "PipelineStepRunPostMappingHooks",
  ForceRunPostMappingHooks = "ForceRunPostMappingHooks",
  ForceRunPostUploadHooks = "ForceRunPostUploadHooks",
  MalwareFileScan = "MalwareFileScan",
  ShowApiTemplateHooks = "ShowApiTemplateHooks",
  BulkTargetAttributeUpdate = "BulkTargetAttributeUpdate",
  TemplateJsonHooksField = "TemplateJsonHooksField",
  FileFeedsSavedMappings = "FileFeedsSavedMappings",
  MultiUseSftpPath = "MultiUseSftpPath",
  FileFeedIngestionHooks = "FileFeedIngestionHooks",
  RowUniquenessValidation = "RowUniquenessValidation",
  PosthogDisabled = "PosthogDisabled",
  WorkspacesV1 = "WorkspacesV1",
  Workflows = "Workflows",
  RelationalValidations = "RelationalValidations",
  LegacyForbiddenErrorCode = "LegacyForbiddenErrorCode",
  FileFeedWarningsTriggerPartialImport = "FileFeedWarningsTriggerPartialImport",
  DebugEntities = "DebugEntities",
  LegacyValidationHooksAuthType = "LegacyValidationHooksAuthType",
  AiFeatures = "AiFeatures",
  ParallelValidationCodeHooks = "ParallelValidationCodeHooks",
  WorkflowsPdfExtraction = "WorkflowsPdfExtraction",
  WorkspacesExternalCollaborators = "WorkspacesExternalCollaborators",
  WorkflowsAiClassifyValues = "WorkflowsAiClassifyValues",
  WorkflowsPdfContentSplit = "WorkflowsPdfContentSplit",
  WorkflowsPdfContentSplitAsync = "WorkflowsPdfContentSplitAsync",
  EmailLoginWithSso = "EmailLoginWithSso",
  DisableEmailLogin = "DisableEmailLogin",
  ImporterFixWithAi = "ImporterFixWithAi",
  WorkspacesFixWithAi = "WorkspacesFixWithAi",
  WorkflowsDemo = "WorkflowsDemo",
  InternalApiAuthHeaderAccess = "InternalApiAuthHeaderAccess",
  ExternalAPI = "ExternalAPI",
  WorkflowsCsvAgent = "WorkflowsCsvAgent",
  WorkflowsRuntimeCsvAgent = "WorkflowsRuntimeCsvAgent",
  WorkflowsDuckdbSql = "WorkflowsDuckdbSql",
  WorkflowsSplitMergeDuckdb = "WorkflowsSplitMergeDuckdb",
  WorkflowsFileTransformAgent = "WorkflowsFileTransformAgent",
  WorkflowsTemplateAgent = "WorkflowsTemplateAgent",
  WorkflowsAiCodeReview = "WorkflowsAiCodeReview",
  A11yUserwayWidget = "A11yUserwayWidget",
  OperationalMode = "OperationalMode",
  WorkflowsNoHeaderDetection = "WorkflowsNoHeaderDetection",
  WorkflowsKeepBlankRows = "WorkflowsKeepBlankRows",
  OrgUsageRecord = "OrgUsageRecord",
  WorkflowsTrackCredits = "WorkflowsTrackCredits",
  EnableGetTemplatesExtApi = "EnableGetTemplatesExtApi",
  ImporterExportParquet = "ImporterExportParquet",
  ImporterEventSnapshots = "ImporterEventSnapshots",
  PauseScheduledDeleteEmbeds = "PauseScheduledDeleteEmbeds",
  WorkflowsCallWorkflow = "WorkflowsCallWorkflow",
  WorkflowsValidateAgainstTemplate = "WorkflowsValidateAgainstTemplate",
  AiSettings = "AiSettings",
  LargeFileImportTimeout = "LargeFileImportTimeout",
  ConnectionUploadTimeout = "ConnectionUploadTimeout",
  AvailableLlmProviders = "AvailableLlmProviders",
  AiCodeGeneration = "AiCodeGeneration",
  AiMapping = "AiMapping",
  UsageAndBilling = "UsageAndBilling",
  HuronRoles = "HuronRoles",
  BatchedMappingLookup = "BatchedMappingLookup",
  WorkflowsParallelExecution = "WorkflowsParallelExecution",
  WorkflowsSkipIntermediateCheckpoints = "WorkflowsSkipIntermediateCheckpoints",
  InternalFeatures = "InternalFeatures",
  ConnectionsS3 = "ConnectionsS3",
  ConnectionsGcs = "ConnectionsGcs",
  ConnectionsSqlServer = "ConnectionsSqlServer",
  ConnectionsPostgres = "ConnectionsPostgres",
  ConnectionsAwsSecretsManager = "ConnectionsAwsSecretsManager",
  ConnectionsAzureKeyVault = "ConnectionsAzureKeyVault",
  ConnectionsAzureBlob = "ConnectionsAzureBlob",
  ConnectionsSalesforce = "ConnectionsSalesforce",
  HuronJwt = "HuronJwt",
  WorkflowsXlsxHtmlPreview = "WorkflowsXlsxHtmlPreview",
  WorkflowsPreviewPdfJs = "WorkflowsPreviewPdfJs",
  WorkflowsImportV2 = "WorkflowsImportV2",
  ImportNodeOutputsAsReferences = "ImportNodeOutputsAsReferences",
  PreferCaseSensitivePicklistMatch = "PreferCaseSensitivePicklistMatch",
  WorkflowsProcessingType = "WorkflowsProcessingType",
  WorkflowsInternalErrorDetails = "WorkflowsInternalErrorDetails",
  McpServer = "McpServer",
  FrontendValidationWebhookTimeoutSeconds = "FrontendValidationWebhookTimeoutSeconds",
  WorkflowsAiExtractData = "WorkflowsAiExtractData",
  WorkflowsDecryptFile = "WorkflowsDecryptFile",
  GlobalFiles = "GlobalFiles",
  WorkflowsGoogleSheetsFetch = "WorkflowsGoogleSheetsFetch",
  WorkflowsAzureSharepointFetch = "WorkflowsAzureSharepointFetch",
  WorkflowsS3ManualImport = "WorkflowsS3ManualImport",
  TemplateTags = "TemplateTags",
  GithubSync = "GithubSync",
  WorkflowsS3Source = "WorkflowsS3Source",
  WorkflowsS3Destination = "WorkflowsS3Destination",
  WorkflowsGcsSource = "WorkflowsGcsSource",
  WorkflowsGcsDestination = "WorkflowsGcsDestination",
  WorkflowsAzureBlobSource = "WorkflowsAzureBlobSource",
  WorkflowsAzureBlobDestination = "WorkflowsAzureBlobDestination",
  WorkflowsSqlServerSource = "WorkflowsSqlServerSource",
  WorkflowsAzureSharepointSource = "WorkflowsAzureSharepointSource",
  WorkflowsAzureSharepointDestination = "WorkflowsAzureSharepointDestination",
  DenoTimeoutSeconds = "DenoTimeoutSeconds",
  DuckdbMemoryMib = "DuckdbMemoryMib",
  WorkflowsCsvAgentMaxRows = "WorkflowsCsvAgentMaxRows",
  BlockEntityDeletion = "BlockEntityDeletion",
  WorkflowsCustomFileValidation = "WorkflowsCustomFileValidation",
  SplitListMaxRows = "SplitListMaxRows",
  WorkflowsTranscode = "WorkflowsTranscode",
  EnforceAssetSubresourceIntegrity = "EnforceAssetSubresourceIntegrity",
  WorkflowsFlowgraphExport = "WorkflowsFlowgraphExport",
  WorkflowsFlowgraphImport = "WorkflowsFlowgraphImport",
  WorkflowsFileAgentMaxIterations = "WorkflowsFileAgentMaxIterations",
  SidekiqThrottleConfig = "SidekiqThrottleConfig",
  WorkflowsSalesforcePush = "WorkflowsSalesforcePush",
  WorkflowsSalesforceSchemaFetch = "WorkflowsSalesforceSchemaFetch",
  WorkflowsSalesforceDataFetch = "WorkflowsSalesforceDataFetch",
  CodeHookTimeoutSeconds = "CodeHookTimeoutSeconds",
  WebhookTimeoutSeconds = "WebhookTimeoutSeconds",
  ExternalServiceTimeoutSeconds = "ExternalServiceTimeoutSeconds",
  PdfExtractionTimeoutSeconds = "PdfExtractionTimeoutSeconds",
  NodeRunTimeoutSeconds = "NodeRunTimeoutSeconds",
  WorkflowRunStaleHours = "WorkflowRunStaleHours",
  CodeGenerationTimeoutSeconds = "CodeGenerationTimeoutSeconds",
  WorkflowsAutoBuildValidateRename = "WorkflowsAutoBuildValidateRename",
  DisableAutoLayoutInMigrate = "DisableAutoLayoutInMigrate",
  IncreasedSmartMappingUniqueValuesLimit = "IncreasedSmartMappingUniqueValuesLimit",
  WorkflowsSqlServerFetch = "WorkflowsSqlServerFetch",
  WorkflowsGcsFetch = "WorkflowsGcsFetch",
  CsvAgentMaxInputFileBytes = "CsvAgentMaxInputFileBytes",
  RustGetTimeoutSeconds = "RustGetTimeoutSeconds",
  RustBulkheadReservedThreads = "RustBulkheadReservedThreads",
  WorkflowsSftpFetch = "WorkflowsSftpFetch",
  PylonChat = "PylonChat",
  WorkflowsTransformsApi = "WorkflowsTransformsApi",
}

export enum PermanentFeature {
  Importer = "Importer",
  CodeHooksApi = "CodeHooksApi",
  IncreasedCodeHookTimeout = "IncreasedCodeHookTimeout",
}

export enum AbstractFeature {
  IsOneSchemaTeam = "IsOneSchemaTeam",
}
